import { reworkDate } from "./common";

export const formatDateByGMT = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        // making date without TIMEZONE 
        const baseDateString = reworkDate(dateString).replace(/([+-]\d{2}):(\d{2})$/, '');
        const date = new Date(baseDateString);
        // Check if date is valid
        if (isNaN(date.getTime())) {
            return 'Invalid Date';
        }

        const formattedDate = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        }).format(date);
        
        const formattedDateWithAMPM = formattedDate.replace(/\b(am|pm)\b/, (match) => match.toUpperCase());
        const regex = /([+-]\d{2}):(\d{2})$/;
        const match = dateString.match(regex);
        let gmtOffset = '';
        if (match) {
            let hours = match[1];
            const minutes = match[2];
            hours = hours.replace(/^([+-])0/, '$1');
            gmtOffset = `GMT${hours}${minutes === "00" ? "" : `:${minutes}`}`;
        }
        return `${formattedDateWithAMPM} (${gmtOffset})`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'Invalid Date';
    }
}